import React, { Fragment, useEffect, useState } from 'react'
import "./Dashboard.css"
import Navbar from '../../appShell/Navbar/Navbar'
import Sidebar from '../../appShell/Sidebar/Sidebar'
import { useDispatch, useSelector, shallowEqual } from "react-redux";
import { Navigate, useNavigate } from 'react-router-dom';
import { handleMenuSelection } from '../../utils/utils';
import DatePicker, { registerLocale } from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import fr from 'date-fns/locale/fr';
import { toast } from 'react-toastify';
import Select from 'react-select';
import Chart from 'react-apexcharts'
import { getAvgRateByCategoryBcc, getAvgRateByCategoryInstitution, getComparision, getFiltersInstitution, getFiltersStaff, getListInstitutionsFromCategory, getListInstitutionsFromCategoryAndZone, getListInstitutionsFromZone, getRateByProductInstitution, getRateByProductStaff } from '../../services/http';
import { addMonths } from 'date-fns';
import Loader from '../../components/Loader/Loader';

const Dashboard = () => {

  const dispatch = useDispatch();
  const states = useSelector((state) => state, shallowEqual);
  const navigate = useNavigate();
  const [rate, setRate] = useState()
  const [displayLoader, setDisplayLoader] = useState(true);
  const [comparision, setComparision] = useState(
    {
      options: { "chart": { "id": "comparision" }, "xaxis": { "categories": ["01-2022", "02-2022", "03-2022", "04-2022", "05-2022", "06-2022", "07-2022", "08-2022", "09-2022", "10-2022", "11-2022", "12-2022"] } },
      series: []
    }
    // [
    //   {
    //     options: {
    //       chart: {
    //         id: 'comparision'
    //       },
    //       xaxis: ["01-2022", "02-2022", "03-2022", "04-2022", "05-2022", "06-2022", "07-2022", "08-2022", "09-2022", "10-2022", "11-2022", "12-2022"]
    //     },
    //     series: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0]
    //   }

    // ]
  )
  // { "xaxis": { 
  // "categories": ["01-2022", "02-2022", "03-2022", "04-2022", "05-2022", "06-2022", "07-2022", "08-2022", "09-2022", "10-2022", "11-2022", "12-2022"] }, 
  // "series": [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0] }
  const [avgRate, setAvgRate] = useState()
  const [filterProducts, setFilterProducts] = useState([])
  const [filterCategoryProducts, setFilterCategoryProducts] = useState([])
  const [filterCategoryInstitutions, setFilterCategoryInstitutions] = useState([])
  const [filterZones, setFilterZones] = useState([])
  const [filterInstitiutionsAvg, setFilterInstitutionsAvg] = useState([])
  const [filterInstitiutionsRate, setFilterInstitutionsRate] = useState([])
  const [filterInstitiutionsComparision, setFilterInstitutionsComparision] = useState([{ value: "", label: "" }])
  const [avgRateInstitution, setAvgRateInstitution] = useState()
  const [avgRateStaff, setAvgRateSTaff] = useState()
  const [rateInstitution, setRateInstitution] = useState()
  const [rateStaff, setRateStaff] = useState()

  const [avgRateParams, setAvgRateParams] = useState({ institution: { value: "", label: "" }, institutionCategory: { value: "", label: "" }, zone: { value: "", label: "" } })
  const [rateParams, setRateParams] = useState({ produit: { value: "", label: "" }, institution: { value: "", label: "" }, institutionCategory: { value: "", label: "" }, zone: { value: "", label: "" } })
  const [comparasionParams, setComparasionParams] = useState({ institution: [], institutionCategory: { value: "", label: "" }, productCategory: { value: "", label: "" }, zone: { value: "", label: "" } })

  useEffect(async () => {

    var staff_filters_response = await getFiltersStaff(states.userToken.access_token);
    var institution_filters_response = await getFiltersInstitution(states.userToken.access_token);

    const data = {
      "institution": "",
      "institutions": "",
      "zone": "",
      "debut": "",
      "fin": "",
      "institutionCategory": "",
      "category_product": ""
    }
    var avg_rate_response, rate_response, response;

    // Start Loading Chart by Default
    if (states.userPermissions?.chart_taux_moyen_staff !== undefined || states.userPermissions?.chart_evolution_taux_staff !== undefined) {
      avg_rate_response = await getAvgRateByCategoryBcc(states.userToken.access_token, data);
      rate_response = await getRateByProductStaff(states.userToken.access_token, data);
      response = await getComparision(states.userToken.access_token, data);
    } else {
      console.log("Toc toc", avg_rate_response)
      avg_rate_response = await getAvgRateByCategoryInstitution(states.userToken.access_token, data);
      rate_response = await getRateByProductInstitution(states.userToken.access_token, data);


    }

    if (avg_rate_response.response && avg_rate_response.response.status === 500) {

      // toast.error("Aucune donnée pour les filtres définis", {
      //   position: toast.POSITION.TOP_RIGHT,
      //   className: 'rotateY animated'
      // });

    } else {
      // console.log(avg_rate_response?.data[0]?.xaxis)

      const chart_data =
      {
        options: {
          chart: {
            id: 'avg-rate'
          },
          fill: {
            // colors: undefined,
            opacity: 0.9,
            type: 'gradient',
            gradient: {
              shade: 'light',
              shadeIntensity: 0.5,
              type: "horizontal",
              shadeIntensity: 0.5,
              // gradientToColors: undefined,
              inverseColors: true,
              opacityFrom: 0.45,
              opacityTo: 0.05,
              stops: [20, 100, 100, 100],
              // colorStops: []
            },
          },

          xaxis: avg_rate_response?.data[0]?.xaxis,
          stroke: {
            curve: 'smooth',
          }
        },
        series: avg_rate_response.data[0]?.series
      }
      setAvgRate(chart_data)
      setDisplayLoader(false);
    }

    if (rate_response.response && rate_response.response.status === 500) {

      // toast.error("Aucune donnée pour les filtres définis", {
      //   position: toast.POSITION.TOP_RIGHT,
      //   className: 'rotateY animated'
      // });

    } else {
      console.log(rate_response?.data[0]?.xaxis)

      const chart_data =
      {
        options: {
          chart: {
            id: 'rate'
          },
          xaxis: rate_response?.data[0]?.xaxis,
          stroke: {
            curve: 'smooth',
          }
        },
        series: rate_response.data[0]?.series
      }
      setRate(chart_data)
      setDisplayLoader(false);
    }

    if (response?.response && response?.response?.status === 500) {

      // toast.error("Aucune donnée pour les filtres définis", {
      //   position: toast.POSITION.TOP_RIGHT,
      //   className: 'rotateY animated'
      // });



    } else {

      const chart_data =
      {
        options: {
          chart: {
            id: 'comparision'
          },
          xaxis: response?.data[0]?.xaxis,
          stroke: {
            curve: 'smooth',
          }
        },
        series: response?.data[0]?.series
      }
      setComparision(chart_data)
      setDisplayLoader(false);
    }
    // End Loading Chart by Default

    const products_data = []
    const category_products_data = []
    const category_institutions_data = []
    const zones_data = []
    const institutions_data = []

    products_data.push({ value: "all", label: "Tous" })
    // category_products_data.push({ value: "all", label: "Toutes" })
    category_institutions_data.push({ value: "all", label: "Toutes" })
    zones_data.push({ value: "all", label: "Toutes" })
    institutions_data.push({ value: "all", label: "Tous" })

    if (states.userPermissions?.chart_taux_moyen_staff !== undefined || states.userPermissions?.chart_evolution_taux_staff !== undefined) {
      console.log("Okay Test")
console.log("rateParams.institution ", rateParams.institution)
      
        staff_filters_response.data.products?.map(value => (products_data.push({
        value: value.id,
        label: value.libelle
      })))
    

      console.log("Here ", staff_filters_response.data.institutions)
      staff_filters_response.data.institutions?.map(value => (institutions_data.push({
        value: value.id,
        label: value.libelle
      })))

      staff_filters_response.data.category_institutions?.map(value => (category_institutions_data.push({
        value: value.id,
        label: value.libelle
      })))

      staff_filters_response.data.zones?.map(value => (zones_data.push({
        value: value.id,
        label: value.libelle
      })))

      staff_filters_response.data.category_products?.map(value => (category_products_data.push({
        value: value.id,
        label: value.libelle
      })))

    } else {
      console.log(institution_filters_response.data)
      institution_filters_response.data.zones?.map(value => (zones_data.push({
        value: value.id,
        label: value.libelle
      })))

      institution_filters_response.data.products?.map(value => (products_data.push({
        value: value.id,
        label: value.libelle
      })))
    }
    console.log("Zone data ", zones_data)
    console.log("Products data ", products_data)

    setFilterProducts(products_data)
    setFilterCategoryInstitutions(category_institutions_data)
    setFilterInstitutionsAvg(institutions_data)
    setFilterInstitutionsRate(institutions_data)
    var temArray = institutions_data.shift()
    setFilterInstitutionsComparision(institutions_data)
    setFilterZones(zones_data)
    setFilterCategoryProducts(category_products_data)

    // console.log("avg_bcc_response ", avg_bcc_response?.data)
    // console.log("avg_institution_response ", avg_institution_response?.data)
    // console.log("rate_staff_response ", rate_staff_response?.data)
    // console.log("rate_institution_response ", rate_institution_response?.data)
    // console.log("staff_filters_response ", staff_filters_response?.data)
    // console.log("institution_filters_response ", institution_filters_response?.data)

  }, [])


  // Taux Moyen par catégorie(Institutions Filters)
  useEffect(async () => {
    const institutions_data = []
    institutions_data.push({ value: "all", label: "Tous" })

    if (states.userPermissions?.chart_taux_moyen_staff !== undefined) {

      if (avgRateParams.institutionCategory.value !== "" && avgRateParams.zone.value === "") {
        let list_instit;
        if (avgRateParams.institutionCategory.value === "all") {
          list_instit = await getFiltersStaff(states.userToken.access_token);
          console.log(list_instit.data)
          list_instit.data?.institutions?.map(value => (institutions_data.push({
            value: value.id,
            label: value.libelle
          })))
        } else {
          list_instit = await getListInstitutionsFromCategory(states.userToken.access_token, avgRateParams.institutionCategory?.value)
          console.log(list_instit.data)
          list_instit.data?.map(value => (institutions_data.push({
            value: value.id,
            label: value.libelle
          })))
        }
      }

      if (avgRateParams.zone.value !== "" && avgRateParams.institutionCategory === "") {
        let list_instit;
        if (avgRateParams.zone.value === "all") {
          list_instit = await getFiltersStaff(states.userToken.access_token);
          list_instit.data?.institutions?.map(value => (institutions_data.push({
            value: value.id,
            label: value.libelle
          })))
        } else {
          list_instit = await getListInstitutionsFromZone(states.userToken.access_token, avgRateParams.zone?.value)
          list_instit.data?.map(item => (institutions_data.push({
            value: item.id,
            label: item.libelle
          })))
        }
      }

      if (avgRateParams.institutionCategory.value !== "" && avgRateParams.zone.value !== "") {
        let list_instit;
        if (avgRateParams.zone.value === "all" && avgRateParams.institutionCategory.value === "all") {
          list_instit = await getFiltersStaff(states.userToken.access_token);
          console.log("list_instit.data 1", list_instit.data)
          list_instit.data?.institutions?.map(value => (institutions_data.push({
            value: value.id,
            label: value.libelle
          })))
        } else if (avgRateParams.zone.value !== "all" && avgRateParams.institutionCategory.value !== "all") {
          list_instit = await getListInstitutionsFromCategoryAndZone(states.userToken.access_token, avgRateParams.zone?.value, avgRateParams.institutionCategory?.value)
          console.log("list_instit.data 2", list_instit)
          list_instit.data?.map(value => (institutions_data.push({
            value: value.institution_id,
            label: value.libelle
          })))
        } else if (avgRateParams.zone.value !== "all" && avgRateParams.institutionCategory.value === "all") {
          list_instit = await getListInstitutionsFromZone(states.userToken.access_token, avgRateParams.zone?.value)
          // console.log(list_instit.data[0])
          list_instit.data[0].institutions?.map(value => (institutions_data.push({
            value: value.id,
            label: value.libelle
          })))
        }
        else if (avgRateParams.zone.value === "all" && avgRateParams.institutionCategory.value !== "all") {
          list_instit = await getListInstitutionsFromCategory(states.userToken.access_token, avgRateParams.institutionCategory?.value)
          console.log(list_instit.data)
          list_instit.data?.map(value => (institutions_data.push({
            value: value.id,
            label: value.libelle
          })))
        }

      }

      console.log("Okay Test")

      console.log(institutions_data)
      setFilterInstitutionsAvg(institutions_data)

    }

  }, [avgRateParams.institutionCategory, avgRateParams.zone])


  // Evolution Taux  Staff(Institutions Filters)
  useEffect(async () => {
    const institutions_data = []
    institutions_data.push({ value: "all", label: "Tous" })

    if (states.userPermissions?.chart_evolution_taux_staff !== undefined) {

      if (rateParams.institutionCategory.value !== "" && rateParams.zone.value === "") {
        let list_instit;
        if (rateParams.institutionCategory.value === "all") {
          list_instit = await getFiltersStaff(states.userToken.access_token);
          console.log(list_instit.data)
          list_instit.data?.institutions?.map(value => (institutions_data.push({
            value: value.id,
            label: value.libelle
          })))
        } else {
          list_instit = await getListInstitutionsFromCategory(states.userToken.access_token, rateParams.institutionCategory?.value)
          console.log(list_instit.data)
          list_instit.data?.map(value => (institutions_data.push({
            value: value.id,
            label: value.libelle
          })))
        }
      }

      if (rateParams.zone.value !== "" && rateParams.institutionCategory === "") {
        let list_instit;
        if (rateParams.zone.value === "all") {
          list_instit = await getFiltersStaff(states.userToken.access_token);
          console.log(list_instit)
          list_instit.data?.institutions?.map(value => (institutions_data.push({
            value: value.id,
            label: value.libelle
          })))
        } else {
          list_instit = await getListInstitutionsFromZone(states.userToken.access_token, rateParams.zone?.value)
          list_instit.data?.map(value => (institutions_data.push({
            value: value.id,
            label: value.libelle
          })))
        }
      }

      if (rateParams.institutionCategory.value !== "" && rateParams.zone.value !== "") {
        let list_instit;
        if (rateParams.zone.value === "all" && rateParams.institutionCategory.value === "all") {
          list_instit = await getFiltersStaff(states.userToken.access_token);
          console.log(list_instit.data)
          list_instit.data?.institutions?.map(value => (institutions_data.push({
            value: value.id,
            label: value.libelle
          })))
        } else if (rateParams.zone.value !== "all" && rateParams.institutionCategory.value !== "all") {
          list_instit = await getListInstitutionsFromCategoryAndZone(states.userToken.access_token, rateParams.zone?.value, rateParams.institutionCategory?.value)
          console.log(list_instit)
          list_instit.data?.map(value => (institutions_data.push({
            value: value.institution_id,
            label: value.libelle
          })))
        } else if (rateParams.zone.value !== "all" && rateParams.institutionCategory.value === "all") {
          list_instit = await getListInstitutionsFromZone(states.userToken.access_token, rateParams.zone?.value)
          // console.log(list_instit.data[0])
          list_instit.data[0].institutions?.map(value => (institutions_data.push({
            value: value.id,
            label: value.libelle
          })))
        }
        else if (rateParams.zone.value === "all" && rateParams.institutionCategory.value !== "all") {
          list_instit = await getListInstitutionsFromCategory(states.userToken.access_token, rateParams.institutionCategory?.value)
          console.log(list_instit.data)
          list_instit.data?.map(value => (institutions_data.push({
            value: value.id,
            label: value.libelle
          })))
        }

      }

      console.log("Okay Test")

      console.log(institutions_data)
      setFilterInstitutionsRate(institutions_data)

    }

  }, [rateParams.institutionCategory, rateParams.zone])


  // Comparision Taux  Staff(Institutions Filters)
  useEffect(async () => {
    const institutions_data = []
    // institutions_data.push({ value: "all", label: "Tous" })

    if (states.userPermissions?.chart_evolution_taux_staff !== undefined) {

      if (comparasionParams.institutionCategory.value !== "" && comparasionParams.zone.value === "") {
        let list_instit;
        if (comparasionParams.institutionCategory.value === "all") {
          list_instit = await getFiltersStaff(states.userToken.access_token);
          console.log(list_instit.data)
          list_instit.data?.institutions?.map(value => (institutions_data.push({
            value: value.id,
            label: value.libelle
          })))
        } else {
          list_instit = await getListInstitutionsFromCategory(states.userToken.access_token, comparasionParams.institutionCategory?.value)
          console.log(list_instit.data)
          list_instit.data?.map(value => (institutions_data.push({
            value: value.id,
            label: value.libelle
          })))
        }
      }

      if (comparasionParams.zone.value !== "" && comparasionParams.institutionCategory === "") {
        let list_instit;
        if (comparasionParams.zone.value === "all") {
          list_instit = await getFiltersStaff(states.userToken.access_token);
          list_instit.data?.institutions?.map(value => (institutions_data.push({
            value: value.id,
            label: value.libelle
          })))
        } else {
          list_instit = await getListInstitutionsFromZone(states.userToken.access_token, comparasionParams.zone?.value)
          list_instit.data?.map(value => (institutions_data.push({
            value: value.id,
            label: value.libelle
          })))
        }
      }

      if (comparasionParams.institutionCategory.value !== "" && comparasionParams.zone.value !== "") {
        let list_instit;
        if (comparasionParams.zone.value === "all" && comparasionParams.institutionCategory.value === "all") {
          list_instit = await getFiltersStaff(states.userToken.access_token);
          console.log(list_instit.data)
          list_instit.data?.institutions?.map(value => (institutions_data.push({
            value: value.id,
            label: value.libelle
          })))
        } else if (comparasionParams.zone.value !== "all" && comparasionParams.institutionCategory.value !== "all") {
          list_instit = await getListInstitutionsFromCategoryAndZone(states.userToken.access_token, comparasionParams.zone?.value, comparasionParams.institutionCategory?.value)
          console.log(list_instit)
          list_instit.data?.map(value => (institutions_data.push({
            value: value.id,
            label: value.libelle
          })))
        } else if (comparasionParams.zone.value !== "all" && comparasionParams.institutionCategory.value === "all") {
          list_instit = await getListInstitutionsFromZone(states.userToken.access_token, comparasionParams.zone?.value)
          list_instit.data[0].institutions?.map(value => (institutions_data.push({
            value: value.id,
            label: value.libelle
          })))
        }
        else if (comparasionParams.zone.value === "all" && comparasionParams.institutionCategory.value !== "all") {
          list_instit = await getListInstitutionsFromCategory(states.userToken.access_token, comparasionParams.institutionCategory?.value)
          console.log(list_instit.data)
          list_instit.data?.map(value => (institutions_data.push({
            value: value.id,
            label: value.libelle
          })))
        }

      }

      console.log("Okay Test")

      console.log(institutions_data)
      setFilterInstitutionsComparision(institutions_data)

    }

  }, [comparasionParams.institutionCategory, comparasionParams.zone])

  // To populate the breadcrumb and update the sidebar menu
  useEffect(() => {
    dispatch({
      type: "SET",
      key: "breadcrumbContent",
      payload: {
        firstLevelText: "Tableau de bord", firstLevelLink: "/dashboard", secondLevelText: "", secondLevelLink: "", thirdLevelText: "", thirdLevelLink: ""
      }
    });
    handleMenuSelection("dashboard", dispatch, states);
    // handleSubMenuSelection("institutions-categories", dispatch)
  }, [])

  const [dateRangeAvgRate, setDateRangeAvgRate] = useState([null, null]);
  const [dateRangeRate, setDateRangeRate] = useState([null, null]);
  const [dateRangeComparision, setDateRangeComparasion] = useState([null, null]);
  const [startDateAvgRate, endDateAvgRate] = dateRangeAvgRate;
  const [startDateRate, endDateRate] = dateRangeRate;
  const [startDateComparasion, endDateComparasion] = dateRangeComparision;
  registerLocale('fr', fr);

  useEffect(() => {

    console.log(avgRateParams.institutionCategory)
  }, [avgRateParams.institutionCategory]);

  const handleChangeEntry = (key, e) => {

    let selectedValue = e.currentTarget?.value;
    if (key == "etablissement-avg") {
      var el = document.getElementById('etablissement-avg');
      var text = el.options[el.selectedIndex].innerHTML
      setAvgRateParams({ ...avgRateParams, institution: { value: selectedValue, label: text } })
    }
    if (key == "cat-etablissement-avg") {
      var el = document.getElementById('cat-etablissement-avg');
      var text = el.options[el.selectedIndex].innerHTML
      // setAvgRateParams({ ...avgRateParams, institutionCategory: { value: e.value, label: e.label } })
      setAvgRateParams({ ...avgRateParams, institutionCategory: { value: selectedValue, label: text } })
    }
    if (key == "cat-etablissement-rate") {
      var el = document.getElementById('cat-etablissement-rate');
      var text = el.options[el.selectedIndex].innerHTML
      setRateParams({ ...rateParams, institutionCategory: { value: selectedValue, label: text } })
    }
    if (key == "zone-avg") {
      var el = document.getElementById('zone-avg');
      var text = el.options[el.selectedIndex].innerHTML
      setAvgRateParams({ ...avgRateParams, zone: { value: selectedValue, label: text } })
    }
    if (key == "produit-rate") {
      var el = document.getElementById('produit-rate');
      var text = el.options[el.selectedIndex].innerHTML
      setRateParams({ ...rateParams, produit: { value: selectedValue, label: text } })
    }
    if (key == "etablissement-rate") {
      var el = document.getElementById('etablissement-rate');
      var text = el.options[el.selectedIndex].innerHTML
      setRateParams({ ...rateParams, institution: { value: selectedValue, label: text } })
    }
    if (key == "zone-rate") {
      var el = document.getElementById('zone-rate');
      var text = el.options[el.selectedIndex].innerHTML
      setRateParams({ ...rateParams, zone: { value: selectedValue, label: text } })
    }
    if (key == "instit-categorie-comparision") {
      var el = document.getElementById('instit-categorie-comparision');
      var text = el.options[el.selectedIndex].innerHTML
      setComparasionParams({ ...comparasionParams, institutionCategory: { value: selectedValue, label: text } })
    }
    if (key == "produit-categorie-comparision") {
      var el = document.getElementById('produit-categorie-comparision');
      var text = el.options[el.selectedIndex].innerHTML
      setComparasionParams({ ...comparasionParams, productCategory: { value: selectedValue, label: text } })
    }
    if (key == "etablissement-comparision") {
      let values = []
      e.map(a => values.push({ value: a.value, label: a.label }));
      // console.log("values", typeof values)
      console.log(values)

      setComparasionParams({ ...comparasionParams, institution: values })
    }
    if (key == "zone-comparision") {
      var el = document.getElementById('zone-comparision');
      var text = el.options[el.selectedIndex].innerHTML
      setComparasionParams({ ...comparasionParams, zone: { value: selectedValue, label: text } })
    }
  }

  const handleApplyFilter = async (key) => {
    console.log("avg rate institution ", avgRateParams.institution)

    if (key === "avg-rate") {
      const { institution, zone, institutionCategory } = avgRateParams;
      const debMonth = dateRangeAvgRate[0]?.getMonth() + 1;
      const finMonth = dateRangeAvgRate[1]?.getMonth() + 1;
      const dateDebut = dateRangeAvgRate[0]?.getFullYear() + "-" + (debMonth < 10 ? "0" + debMonth : debMonth);
      const dateFin = dateRangeAvgRate[1]?.getFullYear() + "-" + (finMonth < 10 ? "0" + finMonth : finMonth);
      const data = {
        "institution": institution.value == undefined || institution.value == "all" ? "" : institution.value,
        "institutionCategory": institutionCategory.value == undefined || institutionCategory.value == "all" ? "" : institutionCategory.value,
        "zone": zone.value == undefined || zone.value == "all" ? "" : zone.value,
        "debut": dateDebut !== "undefined-NaN" ? dateDebut : "",
        "fin": dateFin !== "undefined-NaN" ? dateFin : ""
      }

      console.log("data for avg_rate_response ", data.institution);
      var avg_rate_response;
      if (states.userPermissions?.chart_taux_moyen_staff !== undefined) {
        avg_rate_response = await getAvgRateByCategoryBcc(states.userToken.access_token, data);

      } else {
        avg_rate_response = await getAvgRateByCategoryInstitution(states.userToken.access_token, data);

      }
      console.log("avg_rate_response.data", avg_rate_response.data)

      if (avg_rate_response.response && avg_rate_response.response.status === 500) {

        toast.error("Aucune donnée pour les filtres définis", {
          position: toast.POSITION.TOP_RIGHT,
          className: 'rotateY animated'
        });

      } else {
        console.log("avg_rate_response ", avg_rate_response)

        const chart_data =
        {
          options: {
            chart: {
              id: 'avg-rate'
            },
            xaxis: avg_rate_response?.data[0]?.xaxis,
            stroke: {
              curve: 'smooth',
            }
          },
          series: avg_rate_response.data[0]?.series
        }
        setAvgRate(chart_data)
        setDisplayLoader(false);
      }

    }



    if (key === "rate") {

      const { institution, zone, institutionCategory, produit } = rateParams;

      const debMonth = dateRangeRate[0]?.getMonth() + 1;
      const finMonth = dateRangeRate[1]?.getMonth() + 1;
      const dateDebut = dateRangeRate[0]?.getFullYear() + "-" + (debMonth < 10 ? "0" + debMonth : debMonth);
      const dateFin = dateRangeRate[1]?.getFullYear() + "-" + (finMonth < 10 ? "0" + finMonth : finMonth);
      const data = {
        "institution": institution.value == undefined || institution.value == "all" ? "" : institution.value,
        "produit": produit.value == undefined || produit.value == "all" ? "" : produit.value,
        "institutionCategory": institutionCategory.value == undefined || institutionCategory.value == "all" ? "" : institutionCategory.value,
        "zone": zone.value == undefined || zone.value == "all" ? "" : zone.value,
        "debut": dateDebut !== "undefined-NaN" ? dateDebut : "",
        "fin": dateFin !== "undefined-NaN" ? dateFin : ""
      }

      console.log(data);
      console.log(states.userPermissions?.chart_evolution_taux_staff)
      var rate_response;
      if (states.userPermissions?.chart_evolution_taux_staff !== undefined) {
        rate_response = await getRateByProductStaff(states.userToken.access_token, data);

      } else {
        rate_response = await getRateByProductInstitution(states.userToken.access_token, data);

      }
      console.log(rate_response)
      console.log(rate_response?.data[0]?.xaxis)
      console.log(rate_response?.data[0]?.series)

      if (rate_response.response && rate_response.response.status === 500) {
        toast.error("Aucune donnée pour les filtres définis", {
          position: toast.POSITION.TOP_RIGHT,
          className: 'rotateY animated'
        });

      } else {
        // console.log(rate_response.data[0])


        const chart_data =
        {
          options: {
            chart: {
              id: 'rate'
            },
            xaxis: rate_response?.data[0]?.xaxis,
            stroke: {
              curve: 'smooth',
            }
          },
          series: rate_response.data[0]?.series
        }
        setRate(chart_data)
      }

    }

    if (key === "comparision") {
      const { institution, productCategory } = comparasionParams;

      console.log(comparasionParams)

      var etablissements = [];

      institution.map(item => etablissements.push(item.value))

      const debMonth = dateRangeComparision[0]?.getMonth() + 1;
      const finMonth = dateRangeComparision[1]?.getMonth() + 1;
      const dateDebut = dateRangeComparision[0]?.getFullYear() + "-" + (debMonth < 10 ? "0" + debMonth : debMonth);
      const dateFin = dateRangeComparision[1]?.getFullYear() + "-" + (finMonth < 10 ? "0" + finMonth : finMonth);
      const data = {
        "institution": institution?.length < 2 ? "" : etablissements,
        "productCategory": productCategory.value == undefined || productCategory.value == "all" ? "" : productCategory.value,
        "debut": dateDebut !== "undefined-NaN" ? dateDebut : "",
        "fin": dateFin !== "undefined-NaN" ? dateFin : ""
      }

      console.log(data);
      var response;
      if (states.userPermissions?.chart_evolution_taux_staff !== undefined) {
        response = await getComparision(states.userToken.access_token, data);

      }
      // else {
      //   response = await getRateByProductInstitution(states.userToken.access_token, data);

      // }
      console.log("Test instit", response.data[0])

      if (response.response && response.response.status === 500) {

        // toast.error("Aucune donnée pour les filtres définis", {
        //   position: toast.POSITION.TOP_RIGHT,
        //   className: 'rotateY animated'
        // });


      } else {
        console.log(response?.data[0]?.xaxis)

        const chart_data =
        {
          options: {
            chart: {
              id: 'comparision'
            },
            xaxis: response?.data[0]?.xaxis,
            stroke: {
              curve: 'smooth',
            }
          },
          series: response.data[0]?.series
        }
        setComparision(chart_data)
        setDisplayLoader(false);
      }
    }


  }
  useEffect(() => {


    console.log("userInfo ", states.userInfo.isAdmin)
  }, []);

  const customStyles2 = {
    control: (provided, state) => ({
      ...provided,
      background: '#fff',
      borderColor: '#9e9e9e',
      minHeight: '35px',
    //   height: '35px',
      boxShadow: state.isFocused ? null : null,
    }),

    valueContainer: (provided, state) => ({
      ...provided,
      minHeight: '35px',
      padding: '0 6px',
    //   marginTop: '-5px'
    }),

    input: (provided, state) => ({
      ...provided,
      margin: '0px',
    }),
    indicatorSeparator: state => ({
      display: 'none',
    //   height: '30px'
    }),
    indicatorsContainer: (provided, state) => ({
      ...provided,
      minHeight: '35px',
    }),
  };

  return (
    <div>
      <Navbar />
      <div className="main-container" id="container">
        <Sidebar />

        <div id="content" className="main-content">
          {displayLoader == false ?
            <div className="layout-px-spacing">

              <div className="row layout-top-spacing">
                <div className="col-xl-12 col-lg-12 col-sm-12  layout-spacing">
                </div>
              </div>

              <h3 className="text-left">Tableau de bord</h3>



              {/* Start Taux Moyens */}
              <div className="widget widget-content widget-content-area p-3 mt-3 mb-5">
                <h5 className="text-left">Taux Moyens par catégorie de produits</h5>
                {/* <p>{states.userPermissions.list_product !== undefined && 0} </p> */}

                <div className=" d-flex justify-content-between  flex-wrap my-4">

                  {states.userPermissions?.chart_taux_moyen_staff !== undefined &&
                    <div className="col-sm-4 col-xs-12 mb-2">
                      <div className='truncate'>Catégorie d'etablissements</div>
                      <select id="cat-etablissement-avg" onChange={(e) => handleChangeEntry("cat-etablissement-avg", e)} className={"form-control custom-form-control basic mb-2 mr-2 "}>
                        <option disabled selected hidden value=""> </option>
                        {filterCategoryInstitutions !== [] && filterCategoryInstitutions?.map((item) => (
                          <option key={item.value} value={item.value}>{item.label}</option>
                        ))}
                      </select>
                    </div>
                  }

                  {states.userPermissions?.chart_taux_moyen_staff !== undefined &&
                    <div className="col-sm-4 col-xs-12 mb-2">
                      <div>Zone</div>
                      <select id="zone-avg" onChange={(e) => handleChangeEntry("zone-avg", e)} className={"form-control custom-form-control basic"}>
                        <option disabled selected hidden value=""> </option>
                        {filterZones !== [] && filterZones?.map((item) => (
                          <option key={item.value} value={item.value}>{item.label}</option>
                        ))}
                      </select>
                    </div>
                  }

                  <div className={" col-sm-3 col-xs-12 p-0 mb-2"}></div>


                  {states.userPermissions?.chart_taux_moyen_staff !== undefined &&
                    <div className="col-sm-4 col-xs-12">
                      <div>Etablissement</div>
                      <select id="etablissement-avg" onChange={(e) => handleChangeEntry("etablissement-avg", e)} className={"form-control custom-form-control basic mb-2"}>
                        <option disabled selected hidden value=""> </option>
                        {filterInstitiutionsAvg !== [] && filterInstitiutionsAvg?.map((item) => (
                          <option key={item.value} value={item.value}>{item.label}</option>
                        ))}
                      </select>
                    </div>

                  }


                  {/* End Select */}

                  <div className={" col-sm-4 col-xs-12 mb-2"}>
                    <div className='truncate'>Mois(Début) - Mois(Fin)</div>
                    <DatePicker
                      selectsRange={true}
                      startDate={startDateAvgRate}
                      endDate={endDateAvgRate}
                      dateFormat="MM/yyyy"
                      locale="fr"
                      onChange={(update) => {
                        setDateRangeAvgRate(update);
                      }}
                      isClearable={false}
                      placeholderText=""
                      showMonthYearPicker
                      showFullMonthYearPicker
                      className={"form-control custom-form-control basic "}
                      onChangeRaw={(e) => e.preventDefault()}
                      maxDate={new Date()}
                    // includeDateIntervals={[
                    //   { start: startDateAvgRate ? startDateAvgRate : null, end:startDateAvgRate ? addMonths(startDateAvgRate, 5) : null},
                    // ]}
                    />
                  </div>
                  <div className={"col-sm-3 col-xs-12 d-flex align-items-end"}>
                    <button style={{ height: "35px", width: "100%" }} className="btn btn-dark mb-2" onClick={() => handleApplyFilter("avg-rate")}>Appliquer</button>
                  </div>
                  <div className={"col-sm-3 col-xs-12"}></div>

                </div>

                <p>
                  {(avgRate?.options && avgRate?.series) ? <Chart options={avgRate?.options} series={avgRate?.series} type="area" width={"100%"} height={320} /> : <h4 className='py-3'>Aucune donnée</h4>}
                </p>
              </div>
              {/* End Taux Moyens */}

              {/* Start Taux Evolution */}
              <div className="widget widget-content widget-content-area p-3 mt-3 mb-5">
                <h5 className="text-left">Evolution du taux par produit</h5>

                <div className=" d-flex justify-content-between flex-wrap my-3">

                  {states.userPermissions?.chart_taux_moyen_staff !== undefined &&
                    <div className="col-sm-4 col-xs-12">
                      <div className='truncate'>Catégorie d'etablissements</div>
                      <select id="cat-etablissement-rate" onChange={(e) => handleChangeEntry("cat-etablissement-rate", e)} className={"form-control custom-form-control basic mb-2"}>
                        <option disabled selected hidden value=""> </option>
                        {filterCategoryInstitutions !== [] && filterCategoryInstitutions?.map((item) => (
                          <option key={item.value} value={item.value}>{item.label}</option>
                        ))}
                      </select>
                    </div>
                  }
                  {states.userPermissions?.chart_taux_moyen_staff !== undefined &&
                    <div className="col-sm-3 col-xs-12">
                      <div>Zone</div>
                      <select id="zone-rate" onChange={(e) => handleChangeEntry("zone-rate", e)} className={"form-control custom-form-control basic"}>
                        <option disabled selected hidden value=""> </option>
                        {filterZones !== [] && filterZones?.map((item) => (
                          <option key={item.value} value={item.value}>{item.label}</option>
                        ))}
                      </select>
                    </div>

                  }
                  {states.userPermissions?.chart_taux_moyen_staff !== undefined &&
                    <div className="col-sm-4 col-xs-12 mb-2">
                      <div>Etablissement</div>
                      <select id="etablissement-rate" onChange={(e) => handleChangeEntry("etablissement-rate", e)} className={"form-control custom-form-control basic mb-2"}>
                        <option disabled selected hidden value=""> </option>
                        {filterInstitiutionsRate !== [] && filterInstitiutionsRate?.map((item) => (
                          <option key={item.value} value={item.value}>{item.label}</option>
                        ))}
                      </select>
                    </div>

                  }

                  {
                    <div className="col-sm-4 col-xs-12 mb-2">
                      <div>Produit</div>
                      <select id="produit-rate" onChange={(e) => handleChangeEntry("produit-rate", e)} className={"form-control custom-form-control basic mb-2"}>
                        <option disabled selected hidden value=""> </option>
                        {filterProducts !== [] && filterProducts?.map((item) => (
                          <option key={item.value} value={item.value}>{item.label}</option>
                        ))}
                      </select>
                    </div>

                  }
                  


                  {/* End Select */}

                  <div className={"col-sm-4 mb-2 col-xs-12"}>
                    <div className='truncate'>Mois(Début) - Mois(Fin)</div>
                    <DatePicker
                      selectsRange={true}
                      startDate={startDateRate}
                      endDate={endDateRate}
                      dateFormat="MM/yyyy"
                      locale="fr"
                      onChange={(update) => {
                        setDateRangeRate(update);
                      }}
                      isClearable={false}
                      placeholderText=""
                      showMonthYearPicker
                      showFullMonthYearPicker
                      className={"form-control custom-form-control basic"}
                      maxDate={new Date()}
                      onChangeRaw={(e) => e.preventDefault()}
                    />
                  </div>
                  <div className={"col-sm-3 col-xs-12 d-flex align-items-end"}>
                    <button style={{ height: "35px", width: "100%" }} className="btn btn-dark my-auto" onClick={() => handleApplyFilter("rate")}>Appliquer</button>
                  </div>

                </div>
                <p>
                  {(rate?.options && rate?.series) ? <Chart options={rate?.options} series={rate?.series} type="area" width={"100%"} height={320} /> : <h4 className='py-3'>Aucune donnée</h4>}
                </p>
              </div>
              {/* End Taux Evolution */}


              {/* Start Comparision */}

              {states.userPermissions?.chart_taux_moyen_staff !== undefined && <div className="widget widget-content widget-content-area p-3 mt-3 mb-5">
                <h5 className="text-left">Comparaison du taux moyen entre établissement pour une catégorie produits</h5>

                <div className=" d-flex flex-wrap justify-content-between my-3">
                  <div className="col-sm-6 col-xs-12 mb-3">
                    <div className='truncate'>Catégorie d'etablissements</div>
                    <select id="instit-categorie-comparision" onChange={(e) => handleChangeEntry("instit-categorie-comparision", e)} className={"form-control custom-form-control basic"}>
                      <option disabled selected hidden value=""> </option>
                      {filterCategoryInstitutions !== [] && filterCategoryInstitutions?.map((item) => (
                        <option key={item.value} value={item.value}>{item.label}</option>
                      ))}
                    </select>
                  </div>


                  <div className="col-sm-6 col-xs-12 mb-3">
                    <div className='truncate'>Catégorie de produits</div>
                    <select id="produit-categorie-comparision" onChange={(e) => handleChangeEntry("produit-categorie-comparision", e)} className={"form-control custom-form-control basic"}>
                      <option disabled selected hidden value=""> </option>
                      {filterCategoryProducts !== [] && filterCategoryProducts?.map((item) => (
                        <option key={item.value} value={item.value}>{item.label}</option>
                      ))}
                    </select>
                  </div>



                 

                  <div className={"col-sm-3 mb-3 col-xs-12"}>
                    <div className='truncate'>Mois(Début) - Mois(Fin)</div>

                    <DatePicker
                      selectsRange={true}
                      startDate={startDateComparasion}
                      endDate={endDateComparasion}
                      dateFormat="MM/yyyy"
                      locale="fr"
                      onChange={(update) => {
                        setDateRangeComparasion(update);
                      }}
                      isClearable={false}
                      placeholderText=""
                      showMonthYearPicker
                      showFullMonthYearPicker
                      className={"form-control custom-form-control basic"}
                      maxDate={new Date()}
                      onChangeRaw={(e) => e.preventDefault()}
                    />
                  </div>

                  {/* Zone Here */}
                  <div className="col-sm-5 col-xs-12 mb-3">
                    <div>Zone</div>
                    <select id="zone-comparision" onChange={(e) => handleChangeEntry("zone-comparision", e)} className={"form-control custom-form-control basic"}>
                      <option disabled selected hidden value=""> </option>
                      {filterZones !== [] && filterZones?.map((item) => (
                        <option key={item.value} value={item.value}>{item.label}</option>
                      ))}
                    </select>
                  </div>
                  {/* Zone Here */}
                  <div className={"col-sm-4 mb-3 col-xs-12 d-flex my-auto"}>
                    <button style={{ height: "35px", width: "100%" }} className="btn btn-dark" onClick={() => handleApplyFilter("comparision")}>Appliquer</button>
                  </div>
                  <div className="col-xs-12 col-sm-3">
                    {/* <div>Etablissements</div>
                    <Select
                      onChange={(e) => handleChangeEntry("etablissement-comparision", e)}
                      placeholder=""
                      className=" basic mb-2"
                      classNamePrefix="select"
                      value={comparasionParams.institution?.length !== 0 && comparasionParams.institution}
                      isMulti
                      isDisabled={false}
                      isLoading={false}
                      isClearable={false}
                      isRtl={false}
                      isSearchable={false}
                      name="etablissement-comparision"
                      options={filterInstitiutionsComparision}
                      styles={customStyles2}
                      noOptionsMessage={() => "Aucune option"}
                      isOptionDisabled={() => comparasionParams.institution?.length >= 3}
                    /> */}
                  </div>

                  <div className="col-xs-12 col-sm-12">
                    <div>Etablissements</div>
                    <Select
                      onChange={(e) => handleChangeEntry("etablissement-comparision", e)}
                      placeholder=""
                      className=" basic mb-2"
                      classNamePrefix="select"
                      value={comparasionParams.institution?.length !== 0 && comparasionParams.institution}
                      isMulti
                      isDisabled={false}
                      isLoading={false}
                      isClearable={false}
                      isRtl={false}
                      isSearchable={false}
                      name="etablissement-comparision"
                      options={filterInstitiutionsComparision}
                      styles={customStyles2}
                      noOptionsMessage={() => "Aucune option"}
                      isOptionDisabled={() => comparasionParams.institution?.length >= 3}
                    />
                  </div>




                  {/* End Select */}





                </div>

                <p>
                  {(comparision?.options && (comparision?.series)) ? <Chart options={comparision?.options} series={comparision?.series} type="area" width={"100%"} height={320} /> : <h4 className='py-3'>Aucune donnée</h4>}
                </p>
              </div>}
              {/* End Comparision */}

            </div> : <div style={{ marginTop: "25%" }}>
              <Loader />
            </div>}

        </div>
      </div>
    </div>
  )
}

export default Dashboard